import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { FormGroup, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i2 from 'ngx-toastr';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/calendar';
import * as i6 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i7 from 'primeng/table';
import * as i8 from 'primeng/api';
import * as i9 from 'primeng/checkbox';
import * as i10 from 'primeng/radiobutton';
import { PrimengLibraryModule } from 'primeng-library';

class FbCustomDatePickerGroupService {
    constructor(http) {
        this.http = http;
        this.dateSubject = new Subject();
    }
    setDates(startDate, endDate) {
        this.dateSubject.next({ startDate, endDate });
    }
    getDates() {
        return this.dateSubject.asObservable();
    }
    getDuration(payload) {
        return this.http.post(`/vd/formBuilder/get/applyLeave/leaveDurationCalc`, payload).pipe(map((response) => response));
    }
}
FbCustomDatePickerGroupService.ɵfac = function FbCustomDatePickerGroupService_Factory(t) { return new (t || FbCustomDatePickerGroupService)(i0.ɵɵinject(i1.HttpClient)); };
FbCustomDatePickerGroupService.ɵprov = i0.ɵɵdefineInjectable({ token: FbCustomDatePickerGroupService, factory: FbCustomDatePickerGroupService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbCustomDatePickerGroupService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function FbCustomDatePickerGroupComponent_em_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 11);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function FbCustomDatePickerGroupComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function FbCustomDatePickerGroupComponent_em_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 11);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function FbCustomDatePickerGroupComponent_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_1_th_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r11 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(column_r11);
} }
function FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Leave Dates");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_1_th_3_Template, 2, 1, "th", 20);
    i0.ɵɵelement(4, "th");
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵelementStart(6, "p-checkbox", 21);
    i0.ɵɵlistener("onChange", function FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_1_Template_p_checkbox_onChange_6_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(3); ctx_r12.toggleSelectFirstHalf("First Half", $event); return ctx_r12.calcDuration(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, " \u00A0");
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, "Select All");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵelementStart(11, "p-checkbox", 21);
    i0.ɵɵlistener("onChange", function FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_1_Template_p_checkbox_onChange_11_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(3); ctx_r14.toggleSelectSecondHalf("Second Half", $event); return ctx_r14.calcDuration(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, " \u00A0");
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵtext(14, "Select All");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r9 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", columns_r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", "First Half")("formControl", ctx_r7.selectAllFirstHalf);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("value", "Second Half")("formControl", ctx_r7.selectAllSecondHalf);
} }
function FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_2_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "td");
} }
function FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_2_td_3_Template, 1, 0, "td", 20);
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵelementStart(6, "p-radioButton", 23);
    i0.ɵɵlistener("click", function FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_2_Template_p_radioButton_click_6_listener() { i0.ɵɵrestoreView(_r21); const rowData_r15 = ctx.$implicit; const ctx_r20 = i0.ɵɵnextContext(3); ctx_r20.updateRadioValue(rowData_r15, "Full Day"); return ctx_r20.calcDuration(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, " \u00A0");
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, "Full Day");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵelementStart(11, "div", 22);
    i0.ɵɵelementStart(12, "p-radioButton", 23);
    i0.ɵɵlistener("click", function FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_2_Template_p_radioButton_click_12_listener() { i0.ɵɵrestoreView(_r21); const rowData_r15 = ctx.$implicit; const ctx_r22 = i0.ɵɵnextContext(3); ctx_r22.updateRadioValue(rowData_r15, "First Half"); return ctx_r22.calcDuration(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(13, " \u00A0");
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15, "First Half");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵelementStart(17, "div", 22);
    i0.ɵɵelementStart(18, "p-radioButton", 23);
    i0.ɵɵlistener("click", function FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_2_Template_p_radioButton_click_18_listener() { i0.ɵɵrestoreView(_r21); const rowData_r15 = ctx.$implicit; const ctx_r23 = i0.ɵɵnextContext(3); ctx_r23.updateRadioValue(rowData_r15, "Second Half"); return ctx_r23.calcDuration(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(19, " \u00A0");
    i0.ɵɵelementStart(20, "span");
    i0.ɵɵtext(21, "Second Half");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r15 = ctx.$implicit;
    const columns_r16 = ctx.columns;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(rowData_r15);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r16);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", "Full Day")("formControlName", rowData_r15);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", "First Half")("formControlName", rowData_r15);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", "Second Half")("formControlName", rowData_r15);
} }
const _c0 = function () { return { "min-width": "30rem" }; };
function FbCustomDatePickerGroupComponent_div_16_p_table_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-table", 17);
    i0.ɵɵtemplate(1, FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_1_Template, 15, 5, "ng-template", 18);
    i0.ɵɵtemplate(2, FbCustomDatePickerGroupComponent_div_16_p_table_7_ng_template_2_Template, 22, 8, "ng-template", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", ctx_r6.getWeekdays(ctx_r6.startDateFieldVal.value, ctx_r6.endDateFieldVal.value))("tableStyle", i0.ɵɵpureFunction0(2, _c0));
} }
const _c1 = function (a0, a1) { return { "toggle-text-yes": a0, "toggle-text-no": a1 }; };
function FbCustomDatePickerGroupComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Apply for Partial Leave");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-slide-toggle", 14);
    i0.ɵɵlistener("change", function FbCustomDatePickerGroupComponent_div_16_Template_mat_slide_toggle_change_4_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.toggleTable(); });
    i0.ɵɵelementStart(5, "span", 15);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, FbCustomDatePickerGroupComponent_div_16_p_table_7_Template, 3, 3, "p-table", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r4.radioVal);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r4.datesSelected);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c1, ctx_r4.showTable, !ctx_r4.showTable));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.showTable ? "YES" : "NO");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.showTable);
} }
function FbCustomDatePickerGroupComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Applied Duration");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r5.calculatedDuration.value);
} }
const _c2 = function (a0) { return { "width": a0 }; };
class FbCustomDatePickerGroupComponent {
    constructor(fb, toastr, fbCustomDatePickerGroupService, cdRef) {
        this.fb = fb;
        this.toastr = toastr;
        this.fbCustomDatePickerGroupService = fbCustomDatePickerGroupService;
        this.cdRef = cdRef;
        this.radioVal = new FormGroup({});
        this.isEndDateDisabled = true;
        this.datesSelected = false;
        this.showTable = false;
        this.selectedRadioValues = {};
        this.selectAllStates = {};
        this.columnsData = ['Full Day', 'First Half', 'Second Half'];
    }
    ngOnInit() {
        this.currentDate = new Date();
        this.firstDayOfTheMonth = moment().startOf('month').toDate();
        let startDateVal = this.inputParams.value && this.inputParams.value.startDateFieldVal ? this.inputParams.value.startDateFieldVal : '';
        let endDateVal = this.inputParams.value && this.inputParams.value.endDateFieldVal ? this.inputParams.value.endDateFieldVal : '';
        let radioVal = this.inputParams.value && this.inputParams.value.radioVal ? this.inputParams.value.radioVal : '';
        let totalDurationVal = this.inputParams.value && this.inputParams.value.totalDuration ? this.inputParams.value.totalDuration : '';
        const dateValidators = this.inputParams.mandatory ? [Validators.required] : [];
        this.startDateFieldVal = new FormControl(startDateVal, dateValidators);
        this.endDateFieldVal = new FormControl(endDateVal, dateValidators);
        this.selectAllFirstHalf = new FormControl();
        this.selectAllSecondHalf = new FormControl();
        this.calculatedDuration = new FormControl(totalDurationVal);
        this.group.addControl(this.inputParams.name, new FormGroup({
            startDateFieldVal: this.startDateFieldVal,
            endDateFieldVal: this.endDateFieldVal,
            radioVal: this.radioVal,
            totalDuration: this.calculatedDuration
        }));
        const weekdays = this.getWeekdays(startDateVal, endDateVal);
        for (const date of weekdays) {
            this.selectedRadioValues[date] = '';
        }
        for (const columnName of this.columnsData) {
            this.selectAllStates[columnName] = false;
        }
        this.group.valueChanges.subscribe(val => {
            var _a, _b;
            this.leaveTypeId = (_a = val['Leave Type']) === null || _a === void 0 ? void 0 : _a.code;
            this.leaveCategoryId = (_b = val['Leave Category']) === null || _b === void 0 ? void 0 : _b.code;
        });
    }
    checkStartAndEndDatesSelected() {
        this.datesSelected = !!this.startDateFieldVal.value && !!this.endDateFieldVal.value;
    }
    updateRadioValue(date, value) {
        const previousValue = this.selectedRadioValues[date];
        this.selectedRadioValues[date] = value;
        const radioFormGroup = this.group.controls[this.inputParams.name];
        const radioGroup = radioFormGroup.controls['radioVal'];
        if (previousValue && previousValue !== value) {
            if (previousValue === 'First Half') {
                this.selectAllFirstHalf.patchValue(false);
            }
            else if (previousValue === 'Second Half') {
                this.selectAllSecondHalf.patchValue(false);
            }
        }
        radioGroup.patchValue(this.selectedRadioValues);
    }
    toggleSelectFirstHalf(columnName, e) {
        if (e.checked) {
            this.toggleSelectAll('First Half');
            this.selectAllSecondHalf.patchValue(false);
        }
        else {
            this.toggleSelectAll(null);
        }
    }
    toggleSelectSecondHalf(columnName, e) {
        if (e.checked) {
            this.toggleSelectAll('Second Half');
            this.selectAllFirstHalf.patchValue(false);
        }
        else {
            this.toggleSelectAll(null);
        }
    }
    toggleSelectAll(columnName) {
        //this.selectAllStates[columnName] = !this.selectAllStates[columnName];
        const selectedValue = columnName;
        const radioFormGroup = this.group.controls[this.inputParams.name];
        const radioGroup = radioFormGroup.controls['radioVal'];
        const weekdays = this.getWeekdays(radioFormGroup.controls['startDateFieldVal'].value, radioFormGroup.controls['endDateFieldVal'].value);
        const updatedColumnRadioButtons = {};
        weekdays.forEach(date => {
            if (selectedValue) {
                updatedColumnRadioButtons[date] = selectedValue;
                this.selectedRadioValues[date] = selectedValue;
            }
            else {
                delete this.selectedRadioValues[date];
                updatedColumnRadioButtons[date] = '';
            }
        });
        radioGroup.patchValue(updatedColumnRadioButtons);
    }
    startDateChange(event) {
        var _a;
        //this.isEndDateDisabled = false;
        let setDate = moment(event).format("MM/DD/YYYY");
        this.minDateValue = event;
        //this.inputParams.value.startDateFieldVal = setDate; 
        this.group.controls[this.inputParams.name].patchValue({
            startDateFieldVal: setDate
        });
        //this.endDateFieldVal.enable();
        this.createRadioGroupAndControls(false);
        if (this.group.controls[this.inputParams.name].get('startDateFieldVal').value !== "" && this.group.controls[this.inputParams.name].get('endDateFieldVal').value !== "" && ((_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.showDuration) === true) {
            this.calcDuration();
        }
    }
    endDateChange(event) {
        var _a;
        let setDate = moment(event).format("MM/DD/YYYY");
        //this.inputParams.value.endDateFieldVal = setDate;
        this.group.controls[this.inputParams.name].patchValue({
            endDateFieldVal: setDate
        });
        this.createRadioGroupAndControls(false);
        let startDate = this.group.controls[this.inputParams.name].get('startDateFieldVal').value;
        this.fbCustomDatePickerGroupService.setDates(startDate, setDate);
        if (this.group.controls[this.inputParams.name].get('endDateFieldVal').value !== "" && this.group.controls[this.inputParams.name].get('startDateFieldVal').value !== "" && ((_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.showDuration) === true) {
            this.calcDuration();
        }
    }
    createRadioGroupAndControls(selectAllFullDays = false) {
        const radioFormGroup = this.group.controls[this.inputParams.name];
        const radioGroup = radioFormGroup.controls['radioVal'];
        const weekdays = this.getWeekdays(radioFormGroup.controls['startDateFieldVal'].value, radioFormGroup.controls['endDateFieldVal'].value);
        for (const date in radioGroup.value) {
            if (!weekdays.includes(date)) {
                radioGroup.removeControl(date);
            }
        }
        weekdays.forEach(date => {
            radioGroup.addControl(date, new FormControl());
            if (selectAllFullDays || radioGroup.value[date] === null) {
                this.updateRadioValue(date, 'Full Day');
            }
        });
    }
    calcDuration() {
        const outputArray = [];
        for (const date in this.radioVal.value) {
            outputArray.push({
                "leaveDate": date,
                "leaveUnitType": this.radioVal.value[date]
            });
        }
        const payload = {
            "leaveCategoryId": this.leaveCategoryId ? this.leaveCategoryId : 0,
            "leaveEndDate": this.endDateFieldVal.value,
            "leaveStartDate": this.startDateFieldVal.value,
            "leaveTypeId": this.leaveTypeId ? this.leaveTypeId : 0,
            "leaveTypeUnits": outputArray
        };
        this.fbCustomDatePickerGroupService.getDuration(payload).subscribe((response) => {
            if (response.status === 200) {
                this.calculatedDuration.patchValue(response === null || response === void 0 ? void 0 : response.data);
                this.toastr.success(response.message, 'Success');
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            }
        }, (error) => {
            CustomErrorToastComponent.showErrorToast(this.toastr, error);
        });
    }
    toggleTable() {
        this.showTable = !this.showTable;
        this.createRadioGroupAndControls(true);
    }
    getWeekdays(startDate, endDate) {
        const start = moment(startDate, 'MM/DD/YYYY');
        const end = moment(endDate, 'MM/DD/YYYY');
        const weekdays = [];
        while (start.isSameOrBefore(end, 'day')) {
            //const weekdayLabel = start.format('dddd, MMMM D');
            const weekdayLabel = start.format('MM/DD/YYYY');
            weekdays.push(weekdayLabel);
            start.add(1, 'day');
        }
        return weekdays;
    }
    calculateNumberOfDays() {
        const startDate = this.group.controls[this.inputParams.name].get('startDateFieldVal').value;
        const endDate = this.group.controls[this.inputParams.name].get('endDateFieldVal').value;
        if (startDate && endDate) {
            const startMoment = moment(startDate, 'MM/DD/YYYY');
            const endMoment = moment(endDate, 'MM/DD/YYYY');
            let daysDifference = endMoment.diff(startMoment, 'days') + 1;
            const selectedDates = this.getWeekdays(startDate, endDate);
            selectedDates.forEach((date) => {
                const partialLeave = this.selectedRadioValues[date];
                if (partialLeave === 'First Half' || partialLeave === 'Second Half') {
                    daysDifference -= 0.5;
                }
            });
            this.group.controls[this.inputParams.name].get('totalDuration').patchValue(daysDifference);
        }
        else {
            this.group.controls[this.inputParams.name].get('totalDuration').patchValue('');
        }
    }
}
FbCustomDatePickerGroupComponent.ɵfac = function FbCustomDatePickerGroupComponent_Factory(t) { return new (t || FbCustomDatePickerGroupComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(FbCustomDatePickerGroupService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
FbCustomDatePickerGroupComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FbCustomDatePickerGroupComponent, selectors: [["lib-fb-custom-date-picker-group"]], inputs: { formControlName: "formControlName", value: "value", inputParams: "inputParams", group: "group" }, decls: 18, vars: 22, consts: [[1, "form-group", "mt-3", 3, "formGroup"], [1, "label-cls", "w-100"], [1, "row", 3, "formGroupName"], [1, "col-4", "mb-2", "p-0"], [1, "calender-head"], ["class", "error", 4, "ngIf"], ["id", "startDate", "yearRange", "1900:2100", "appendTo", "body", "styleClass", "p-form-datepicker", "yearNavigator", "true", "monthNavigator", "true", "inputId", "startIcon", "formControlName", "startDateFieldVal", "placeholder", "MM/DD/YYYY", 1, "im-input-calendar", "mw-100", 3, "showIcon", "minDate", "onSelect"], [1, "col-4", "mb-2", "p-0", "pl-4"], ["id", "endDate", "yearRange", "1900:2100", "appendTo", "body", "styleClass", "p-form-datepicker", "yearNavigator", "true", "monthNavigator", "true", "inputId", "endIcon", "formControlName", "endDateFieldVal", "placeholder", "MM/DD/YYYY", 1, "im-input-calendar", "mw-100", 3, "showIcon", "minDate", "disabled", "onSelect"], ["class", "partial-leave-container", 3, "formGroup", 4, "ngIf"], ["class", "applied-duration-container col-3", 4, "ngIf"], [1, "error"], [1, "partial-leave-container", 3, "formGroup"], [1, "partial-toggle"], [1, "custom-toggle", 3, "disabled", "change"], [1, "toggle-text", 3, "ngClass"], ["class", "leave-table", 3, "value", "tableStyle", 4, "ngIf"], [1, "leave-table", 3, "value", "tableStyle"], ["pTemplate", "header"], ["pTemplate", "body"], [4, "ngFor", "ngForOf"], ["styleClass", "checkbox-label-allign", 3, "value", "formControl", "onChange"], [1, "partialRadio"], [3, "value", "formControlName", "click"], [1, "applied-duration-container", "col-3"], ["type", "text", "readonly", "", 1, "form-control", 2, "width", "100%", 3, "value"]], template: function FbCustomDatePickerGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵtext(6);
        i0.ɵɵtemplate(7, FbCustomDatePickerGroupComponent_em_7_Template, 2, 0, "em", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "p-calendar", 6);
        i0.ɵɵlistener("onSelect", function FbCustomDatePickerGroupComponent_Template_p_calendar_onSelect_8_listener($event) { ctx.startDateChange($event); return ctx.checkStartAndEndDatesSelected(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, FbCustomDatePickerGroupComponent_span_9_Template, 2, 0, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵelementStart(11, "span", 4);
        i0.ɵɵtext(12);
        i0.ɵɵtemplate(13, FbCustomDatePickerGroupComponent_em_13_Template, 2, 0, "em", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "p-calendar", 8);
        i0.ɵɵlistener("onSelect", function FbCustomDatePickerGroupComponent_Template_p_calendar_onSelect_14_listener($event) { ctx.endDateChange($event); return ctx.checkStartAndEndDatesSelected(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, FbCustomDatePickerGroupComponent_span_15_Template, 2, 0, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, FbCustomDatePickerGroupComponent_div_16_Template, 8, 8, "div", 9);
        i0.ɵɵtemplate(17, FbCustomDatePickerGroupComponent_div_17_Template, 4, 1, "div", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(20, _c2, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width));
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.inputParams == null ? null : ctx.inputParams.label, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.formControlName);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.inputParams == null ? null : ctx.inputParams.properties == null ? null : ctx.inputParams.properties.startDateLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("showIcon", true)("minDate", ctx.inputParams.noMinDate ? null : ctx.firstDayOfTheMonth);
        i0.ɵɵattribute("name", ctx.formControlName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && ctx.group.get(ctx.inputParams.name).touched && ctx.group.get(ctx.inputParams.name).get("startDateFieldVal").value === "");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.inputParams == null ? null : ctx.inputParams.properties == null ? null : ctx.inputParams.properties.endDateLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("showIcon", true)("minDate", ctx.minDateValue)("disabled", !ctx.group.controls[ctx.inputParams.name].value.startDateFieldVal);
        i0.ɵɵattribute("name", ctx.formControlName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && ctx.group.get(ctx.inputParams.name).touched && ctx.group.get(ctx.inputParams.name).get("endDateFieldVal").value === "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.isChecked);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.showDuration);
    } }, directives: [i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.FormGroupName, i4.NgIf, i5.Calendar, i1$1.NgControlStatus, i1$1.FormControlName, i6.MatSlideToggle, i4.NgClass, i7.Table, i8.PrimeTemplate, i4.NgForOf, i9.Checkbox, i1$1.FormControlDirective, i10.RadioButton], styles: [".text-center[_ngcontent-%COMP%]{position:relative;top:10px}.calender-head[_ngcontent-%COMP%]{font-size:15px}.leave-table[_ngcontent-%COMP%]{color:#888;border-top:none!important;font-size:13px}.leave-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-bottom:1px solid #e9ecef!important;padding:15px!important;background-color:#f8f9fa!important;color:#2c2c2c!important;opacity:1!important;font-style:normal;font-weight:600!important;font-size:13px}.leave-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], .leave-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child{border-bottom:1px solid #e9ecef}.leave-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background-color:#f8f9fa!important;color:#2c2c2c!important;opacity:1!important}.applied-duration-container[_ngcontent-%COMP%]{margin-top:12px;margin-left:-14px}.partial-toggle[_ngcontent-%COMP%]{position:relative;bottom:6px}.custom-toggle[_ngcontent-%COMP%]{position:relative;left:12px;top:4px;width:5rem;height:2rem;line-height:2rem;padding:0}.custom-toggle[_ngcontent-%COMP%]   .toggle-text[_ngcontent-%COMP%]{position:absolute;top:0;left:0;right:20px;bottom:0;display:flex;justify-content:center;align-items:center;pointer-events:none}.custom-toggle[_ngcontent-%COMP%]   .toggle-text-yes[_ngcontent-%COMP%]{top:50%;left:-20px;transform:translateY(-50%)}.custom-toggle[_ngcontent-%COMP%]   .toggle-text-no[_ngcontent-%COMP%]{top:50%;right:14px;transform:translateY(-50%)}.durationBtn[_ngcontent-%COMP%]{position:relative;left:320px;bottom:40px}.error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbCustomDatePickerGroupComponent, [{
        type: Component,
        args: [{
                selector: 'lib-fb-custom-date-picker-group',
                templateUrl: 'fb-custom-date-picker-group.component.html',
                styleUrls: ['fb-custom-date-picker-group.component.scss']
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.ToastrService }, { type: FbCustomDatePickerGroupService }, { type: i0.ChangeDetectorRef }]; }, { formControlName: [{
            type: Input
        }], value: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class FbCustomDatePickerGroupModule {
}
FbCustomDatePickerGroupModule.ɵfac = function FbCustomDatePickerGroupModule_Factory(t) { return new (t || FbCustomDatePickerGroupModule)(); };
FbCustomDatePickerGroupModule.ɵmod = i0.ɵɵdefineNgModule({ type: FbCustomDatePickerGroupModule });
FbCustomDatePickerGroupModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            PrimengLibraryModule,
            MatSlideToggleModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FbCustomDatePickerGroupModule, { declarations: [FbCustomDatePickerGroupComponent], imports: [ReactiveFormsModule,
        PrimengLibraryModule,
        MatSlideToggleModule], exports: [FbCustomDatePickerGroupComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbCustomDatePickerGroupModule, [{
        type: NgModule,
        args: [{
                declarations: [FbCustomDatePickerGroupComponent],
                imports: [
                    ReactiveFormsModule,
                    PrimengLibraryModule,
                    MatSlideToggleModule
                ],
                exports: [FbCustomDatePickerGroupComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of fb-custom-date-picker-group
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FbCustomDatePickerGroupComponent, FbCustomDatePickerGroupModule, FbCustomDatePickerGroupService };
//# sourceMappingURL=fb-custom-date-picker-group.js.map
